import { createFrontendModule } from '@backstage/frontend-plugin-api';
import entityFeedbackPlugin from '@backstage-community/plugin-entity-feedback/alpha';
import { EntityRatingsCard } from './EntityRatingsCard';

/*
 * Swap the ratings card's MUI `InfoCard` shell for the BUI one the rest of the
 * info column uses. Overridden through `factory` so the plugin's config schema
 * (title, variant, dialog copy) still reaches the card.
 */
const ratingsButtonsCard = entityFeedbackPlugin
  .getExtension('entity-card:entity-feedback/ratings-buttons')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: {
          loader: async () => (
            <EntityRatingsCard
              title={config.title}
              variant={config.variant}
              requestResponse={config.requestResponse}
              dialogTitle={config.dialogTitle}
              dialogResponses={config.dialogResponses}
            />
          ),
        },
      });
    },
  });

export const entityFeedbackCardsModule = createFrontendModule({
  pluginId: 'entity-feedback',
  extensions: [ratingsButtonsCard],
});
